// import { BrowserRouter as Route, Routes } from 'react-router-dom';
import { Route, Routes } from "react-router-dom";
import Wrap from '../../hoc/Wrap';
import WhiteboardList from "./WhiteboardList";
import { useSelector } from "react-redux";
import NewWhiteboardList from "../NewWhiteBoardContainer/NewWhiteboardList";

const WhiteBoardContainer = () => {
  const isNewUI = useSelector((state) => state.common.isNewUI);
  const WhiteboardListPage=isNewUI?NewWhiteboardList:WhiteboardList
  return (
    <Wrap>  
      <Routes>
        <Route path="/" key={0} layoutType={'App'} element={<WhiteboardListPage/>} />
      </Routes>
  
     
        
    </Wrap>
  );
};






export default WhiteBoardContainer;
